import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { PageHeader } from 'react-bootstrap';
import IconButton from './IconButton';
import Main from './Main';
import hoLogo from '../assets/ho_logo_24x26.png';

const Container = styled.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 10px;
  .spinner {
    margin: 5rem 25%;
  }
  textarea {
    resize: vertical;
  }
  footer {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #eeeeee;
    color: #777777;
    text-align: center;
    font-size: smaller;
    a {
      font-style: italic;
    }
    img {
      height: 10px;
    }
  }
`;

class Page extends React.Component {
  reset = this.reset.bind(this)
  reset() {
    const { onUpdate } = this.props;
    onUpdate(null);
  }

  render() {
    const { storage } = this.props;
    return (
      <Container>
        <PageHeader>
          { storage.token && <IconButton icon="exit" className="pull-right" onClick={this.reset} />}
          Trello Cards
        </PageHeader>
        <Main {...this.props} />
        <footer>
          Developed by Harry Oosterveen, <a href="https://www.harryonline.net/" target="_blank" rel="noopener noreferrer">HarryOnline <img alt="HarryOnline logo" src={hoLogo} /></a>
        </footer>
      </Container>
    );
  }
}

Page.propTypes = {
  storage: PropTypes.object,
  options: PropTypes.object,
  status: PropTypes.object,
  dismiss: PropTypes.func,
  onUpdate: PropTypes.func,
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js